// settleApply/preUploadImg
import {instance as request} from '@/utils/request.js'
export function  preUploadImg(params) {
  return request({
    url:'settleApply/preUploadImg',
    method:'post',
    data:params
  })
}
// /settleApply/uploadProof
export function  settleApplyUploadProof(params,data) {

  return request({
    url:'settleApply/uploadProof',
    method:'post',
    params,
    data,
  })
}